import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames/bind';
import { Communicators } from 'presentation/components/lib/communicators';
import { CustomTextContext } from 'context/CustomTextContext';
import Message from 'presentation/components/Message';
import MessageStack from 'presentation/components/MessageStack';
import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/Message.css';

let cx = classnames.bind(styles);

export default function WelcomeMessage(props) {
  if (!props.isSelfService) {
    let welcomeMessageClasses = props.isDemo ? cx(styles.demoWelcomeMessage) : cx(styles.welcomeMessage);
    return (
      <DeprecatedWelcomeMessage>
        <Message
          className={welcomeMessageClasses}
          content={props.welcomeMessage}
          data-aid="gladlyChatWelcomeMessage"
          sender={''}
        />
      </DeprecatedWelcomeMessage>
    );
  }

  // INTERACTIVE ONBOARDING
  const { onboardingMessage, authenticationAutoResponse } = useContext(CustomTextContext);
  const [shouldDisplayConfirmation, displayConfirmation] = useState(!!(props.isClientReady && props.email));

  // if entering the email, wait 1 second before the confirmation appears
  useEffect(() => {
    const timeout =
      props.isClientReady && !shouldDisplayConfirmation && setTimeout(() => displayConfirmation(true), 1000);
    return () => clearTimeout(timeout);
  });

  const welcomeMessage = [<Message content={onboardingMessage} sender={Communicators.AGENT} key="welcome-message" />];
  const emailMessage = props.email
    ? [<Message content={props.email} sender={Communicators.CUSTOMER} key="email" />]
    : [];
  const confirmationMessage = props.isClientReady
    ? [<Message content={authenticationAutoResponse} sender={Communicators.AGENT} key="confirmation" />]
    : [];

  return (
    <Wrapper>
      <MessageStack messages={welcomeMessage} sender={Communicators.AGENT} />
      <MessageStack messages={emailMessage} sender={Communicators.CUSTOMER} />
      {shouldDisplayConfirmation && <MessageStack messages={confirmationMessage} sender={Communicators.AGENT} />}
    </Wrapper>
  );
}

WelcomeMessage.propTypes = {
  email: PropTypes.string,
  isClientReady: PropTypes.bool,
  isSelfService: PropTypes.bool,
  welcomeMessage: PropTypes.string,
};

const DeprecatedWelcomeMessage = overrideStyle('div')` 
  font-family: ${p => p.theme.fontLibrary.primary};
`;

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.secondary};
`;
